import { createApiSlice } from "@common";
import { CRUD_SEGMENT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addSegmentType",
    method: "post",
    url: CRUD_SEGMENT_TYPE,
    stateKey: "message",
  },
  {
    name: "getSegmentType",
    method: "get",
    url: CRUD_SEGMENT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateSegmentType",
    method: "put",
    url: CRUD_SEGMENT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteSegmentType",
    method: "delete",
    url: CRUD_SEGMENT_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "segmentType",
  apiConfig,
  customReducers);
const segmentTypeSlice = slice;

export default segmentTypeSlice.reducer;

export const {
  addSegmentType,
  getSegmentType,
  updateSegmentType,
  deleteSegmentType,
} = thunks;

export const { rowSelect } = actions;
